import { Component, OnInit } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HelpIndex, Endpoint } from '../../../models/enums';
import { Workflow } from '../../../models/workflow';
import { CommonService } from '../../../services/common/common.service';
import { TargetPickerModalComponent } from '../target-picker-modal/target-picker-modal.component';
import { TargetPickerTreeType } from '../../target-picker-tree/target-picker-tree.component';
import { RestService } from '../../../services/rest/rest.service';

@Component({
    standalone: false,
    selector: 'res-workflow-reporting-options-modal',
    templateUrl: './workflow-reporting-options-modal.component.html',
    styleUrls: ['./workflow-reporting-options-modal.component.scss']
})

export class WorkflowReportingOptionsModalComponent extends BaseModalComponent implements OnInit {
    modalTitle = 'Workflow Reporting Options';
    modalAutomationId = 'workflow-reporting-options';
    modalHelpIndex = HelpIndex.generate_workflow_report_run_dlg;
    modalClass = 'workflow-reporting-options-modal';
    isBusy = false;
    isBusyMessage = 'Running workflow';

    generateCheckbox = true;
    finalCheckbox = false;
    exportCheckbox = false;
    htmlSizes = false;
    workflow: Workflow;
    export: any;

    constructor(private commonService: CommonService, private modalService: BsModalService,
        private modalRef: BsModalRef, private restService: RestService) {
        super(modalService, modalRef);
    }

    isPrimaryBtnEnabled(): boolean {
        return !this.exportCheckbox || this.export.name.length > 0;
    }

    ngOnInit(): void {
        this.clearExport();
        this.workflow = this.modalData as Workflow;
    }

    clearExport(): void {
        this.export = { name: '' };
    }

    changeExport(): void {
        if (this.exportCheckbox) {
            this.finalCheckbox = true;
        } else {
            this.clearExport();
        }
    }

    changeFinal(): void {
        if (this.exportCheckbox && !this.finalCheckbox) {
            this.exportCheckbox = false;
            this.clearExport();
        }
    }

    launchPicker(): void {
        this.commonService.openModal(TargetPickerModalComponent, {
            modalData: { targetPickerTreeType: TargetPickerTreeType.workflowReport },
            class: 'horizontal-px-700 vertical-percent-80'
        }).then(response => {
            if (response && response.modalResult && response.modalData.target) {
                response.modalData.target.name = response.modalData.target.name.replace('CaseData', 'Project Data');
                this.export = response.modalData.target;
                this.htmlSizes = response.modalData.htmlSizes;
            }
        });
    }

    run(): void {
        this.isBusy = true;
        this.restService.post(Endpoint.workFlowManager_processWorkFlow, {
            exportStreamHandle: this.export.name.length > 0 && this.export.data ? this.export.data.handle : null,
            provideExactGeneratedDocSizes: this.htmlSizes,
            searchTermReporting: this.finalCheckbox,
            taskDescription: 'Running Workflow ' + this.workflow.name,
            workFlowHandle: this.workflow.handle
        }).then(response => {
            this.isBusy = false;
            this.closeModal(true, response);

            if (response.errorCode) {
                this.commonService.openErrorModal(response.extendedStatus);
            }
        }).catch(reason => {
            this.isBusy = false;
            this.commonService.openErrorModal(reason.extendedStatus, reason.description);
        });
    }

}
